var _rect, _tspan, _path, _rect2, _tspan2, _path2, _rect3, _tspan3, _path3, _rect4, _tspan4, _path4, _rect5, _tspan5, _path5, _rect6, _tspan6, _path6, _rect7, _tspan7, _path7, _rect8, _tspan8, _path8, _rect9, _tspan9, _path9, _rect10, _tspan10, _path10, _rect11, _tspan11, _path11, _rect12, _tspan12, _path12, _rect13, _tspan13, _path13, _rect14, _tspan14, _path14, _rect15, _tspan15, _path15, _rect16, _tspan16, _path16, _rect17, _tspan17, _path17, _rect18, _tspan18, _path18, _rect19, _tspan19, _tspan20, _path19, _rect20, _tspan21, _path20, _rect21, _tspan22, _path21, _rect22, _tspan23, _tspan24, _path22, _rect23, _tspan25, _path23, _rect24, _tspan26, _path24, _rect25, _tspan27, _tspan28, _path25, _rect26, _tspan29, _path26, _rect27, _tspan30, _path27, _rect28, _tspan31, _path28, _rect29, _tspan32, _path29, _rect30, _tspan33, _path30, _rect31, _tspan34, _tspan35, _path31, _rect32, _tspan36, _path32, _rect33, _tspan37, _path33, _rect34, _tspan38, _path34, _rect35, _tspan39, _path35, _rect36, _tspan40, _path36, _rect37, _tspan41, _path37, _rect38, _tspan42, _path38, _rect39, _tspan43, _path39, _rect40, _tspan44, _path40, _rect41, _tspan45, _path41, _rect42, _tspan46, _path42, _rect43, _tspan47, _path43, _rect44, _tspan48, _path44, _rect45, _tspan49, _path45, _rect46, _tspan50, _path46, _rect47, _tspan51, _path47, _rect48, _tspan52, _path48, _rect49, _tspan53, _path49, _rect50, _tspan54, _path50, _rect51, _tspan55, _path51, _rect52, _tspan56, _path52, _rect53, _tspan57, _path53, _rect54, _tspan58, _path54, _rect55, _tspan59, _path55, _rect56, _tspan60, _path56, _rect57, _tspan61, _path57, _rect58, _tspan62, _path58, _rect59, _tspan63, _path59, _rect60, _tspan64, _path60, _rect61, _tspan65, _path61, _rect62, _tspan66, _path62, _rect63, _tspan67, _path63, _path64, _path65, _tspan68, _tspan69;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrontendRoadmap2023 = function SvgFrontendRoadmap2023(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1514 5926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "web"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 563,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 681.737,
    y: 628.632
  }, "Web\uC758 \uAE30\uCD08")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 386V559",
    stroke: "#333236",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "programming"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 972,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 660.442,
    y: 1037.63
  }, "\uD504\uB85C\uADF8\uB798\uBC0D \uC2DC\uC791")))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 679V968",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "htmlcss"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 1381,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 682.987,
    y: 1446.63
  }, "HTML/CSS")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 1088V1377",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "javascriptweb"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 1966,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 637.832,
    y: 2031.63
  }, "JavaScript \uC6F9 \uAC1C\uBC1C")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 1497V1962",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "cli"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 2375,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 689.79,
    y: 2440.63
  }, "CLI \uAE30\uBCF8\uAE30")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 2082V2371",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "vcs"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 2631,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 657.536,
    y: 2696.63
  }, "\uBC84\uC804 \uAD00\uB9AC \uC2DC\uC2A4\uD15C")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 2491V2627",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "websecurity"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 2887,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 682.762,
    y: 2952.63
  }, "\uC6F9 \uBCF4\uC548 \uC9C0\uC2DD")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 2747V2883",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "packagemanager"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 3143,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 673.055,
    y: 3208.63
  }, "\uD328\uD0A4\uC9C0 \uAD00\uB9AC\uC790")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 3003V3139",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "lintersformatters"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 3399,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 616.316,
    y: 3464.63
  }, "Linters & Formatters")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 3259V3395",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "modulebundlers"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 3655,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 639.267,
    y: 3720.63
  }, "Module Bundlers")))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 3515V3651",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "react"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 4064,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.022em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 713.926,
    y: 4129.63
  }, "React")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 3771V4060",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "moderncss"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 4473,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 672.226,
    y: 4538.63
  }, "Modern CSS")))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 4180V4469",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "cssframeworks"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 4819,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 640.437,
    y: 4884.63
  }, "CSS Frameworks")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 4589V4815",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "authentication"
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 5075,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 652.919,
    y: 5140.63
  }, "Authentication")))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 4935V5071",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "pagerendering"
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 579,
    y: 5484,
    width: 345.809,
    height: 112,
    rx: 56,
    fill: "#FF95AE"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "-0.019em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 647.847,
    y: 5549.63
  }, "Page Rendering")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M751.904 5191V5480",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "web1"
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 580,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 130.063,
    y: 628.256
  }, "\uC778\uD130\uB137\uC758 \uB3D9\uC791 \uC6D0\uB9AC")))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M575 619H559L363.191 619.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "web2"
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 740,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 119.252,
    y: 788.256
  }, "\uBE0C\uB77C\uC6B0\uC800\uC758 \uB3D9\uC791 \uC6D0\uB9AC")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M575 619H560.411C559.498 619 558.612 619.312 557.901 619.885L362.306 777.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "web3"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 579,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185.64,
    y: 627.256
  }, "\uB3C4\uBA54\uC778\uC774\uB780 \uBB34\uC5C7\uC77C\uAE4C?")))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 619H1149.81",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "programming3"
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 976,
    width: 275,
    height: 103,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 1230.69,
    y: 1020.26
  }, "JavaScript \n")), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 1223.76,
    y: 1052.26
  }, "\uB370\uC774\uD130 \uB2E4\uB8E8\uAE30")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 1028H1149.81",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "programming1"
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 989,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 139.454,
    y: 1037.26
  }, "JavaScript \uC2DC\uC791")))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M575 1028.02L363.191 1028.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "programming2"
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 852,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 1184.99,
    y: 900.256
  }, "JavaScript \uD575\uC2EC \uAC1C\uB150")))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 1028H943.622C944.397 1028 945.155 1027.78 945.804 1027.35L1150.46 894.182",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "htmlcss2"
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 1383,
    width: 275,
    height: 103,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 147.213,
    y: 1427.26
  }, "HTML Form\uACFC ")), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 166.719,
    y: 1459.26
  }, "Validation")))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M575 1437H559L363.19 1434.55",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "htmlcss3"
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 1558,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 165.438,
    y: 1606.26
  }, "CSS\uC758 \uC774\uD574")))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M575 1437H560.411C559.498 1437 558.612 1437.31 557.901 1437.89L362.306 1595.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "htmlcss1"
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 1238,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 154.638,
    y: 1286.26
  }, "HTML\uC758 \uC774\uD574")))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M575 1437H560.397C559.493 1437 558.615 1436.69 557.907 1436.13L362.321 1280.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "htmlcss5"
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1154,
    y: 1386,
    width: 275,
    height: 103,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 1210.68,
    y: 1430.26
  }, "\uBC18\uC751\uD615 \uB514\uC790\uC778\uACFC \n")), _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 1234.76,
    y: 1462.26
  }, "\uBBF8\uB514\uC5B4 \uCFFC\uB9AC")))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 1437H1150",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "htmlcss4"
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 1251,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 1200.17,
    y: 1299.26
  }, "CSS \uB808\uC774\uC544\uC6C3 \uAD6C\uC131")))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 1437H943.55C944.37 1437 945.169 1436.75 945.841 1436.28L1150.53 1293.29",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "htmlcss6"
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 1541,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 1266.26,
    y: 1589.26
  }, "Sass")))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 1437H943.564C944.375 1437 945.166 1437.25 945.834 1437.71L1150.52 1578.73",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "javascriptweb2"
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 1983,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 162.497,
    y: 2031.26
  }, "TypeScript")))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M575 2022H559L363 2022.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "javascriptweb3"
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 2143,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 159.86,
    y: 2191.26
  }, "DOM \uB2E4\uB8E8\uAE30")))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M575 2022H560.411C559.498 2022 558.612 2022.31 557.901 2022.89L362.306 2180.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "javascriptweb1"
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 1823,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 104.565,
    y: 1871.26
  }, "JavaScript \uBB38\uBC95\uACFC \uD45C\uD604")))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M575 2022H560.397C559.493 2022 558.615 2021.69 557.907 2021.13L362.321 1865.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "javascriptweb5"
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1154,
    y: 1971,
    width: 275,
    height: 103,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 1221.49,
    y: 2015.26
  }, "\uBE44\uB3D9\uAE30 \uC2E4\uD589\uACFC \n")), _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 1221.92,
    y: 2047.26
  }, "Promise \uAC1D\uCCB4")))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 2022H1150",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "javascriptweb4"
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 1826,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1223.76,
    y: 1874.26
  }, "\uC774\uBCA4\uD2B8 \uB2E4\uB8E8\uAE30")))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 2022H943.481C944.343 2022 945.182 2021.72 945.873 2021.21L1150.6 1868.39",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "javascriptweb6"
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 2126,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 1246,
    y: 2174.26
  }, "Web API")))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 2022H943.564C944.375 2022 945.166 2022.25 945.834 2022.71L1150.52 2163.73",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "cli1"
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 2392,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 155.851,
    y: 2440.26
  }, "CLI \uAE30\uBCF8 \uAC1C\uB150")))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M575 2431.02L363.191 2431.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "cli2"
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1154,
    y: 2390,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 1225.66,
    y: 2438.26
  }, "CLI \uB3C4\uAD6C \uC124\uC815")))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 2430.98L1150 2430.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "vcs1"
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 2648,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 170.993,
    y: 2696.26
  }, "Git \uC0AC\uC6A9\uBC95")))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M575 2687.02L363.191 2687.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "vcs2"
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1154.19,
    y: 2646,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 1252.69,
    y: 2694.26
  }, "GitHub")))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 2686.98L1150.19 2686.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "websecurity1"
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 2904,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 184.13,
    y: 2952.26
  }, "HTTPS")))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M575 2943.02L363.191 2943.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "websecurity2"
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 2902,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 1260.62,
    y: 2950.26
  }, "CORS")))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 2942.98L1149.81 2942.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "packagemanager1"
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 3160,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 195.791,
    y: 3208.26
  }, "npm")))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M575 3199.02L363.191 3199.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "packagemanager2"
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 3158,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 1266.43,
    y: 3206.26
  }, "yarn")))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 3198.98L1149.81 3198.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "lintersformatters1"
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 3416,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 186.315,
    y: 3464.26
  }, "ESLint")))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M575 3455.02L363.191 3455.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "lintersformatters2"
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 3414,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 1249.66,
    y: 3462.26
  }, "Prettier")))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 3454.98L1149.81 3454.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "modulebundlers1"
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 3670,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 1240.24,
    y: 3718.26
  }, "Webpack")))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 3710.98L1149.81 3710.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "react2"
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 4081,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 166.451,
    y: 4129.26
  }, "React \uBC30\uD3EC")))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M575 4120H559L363.191 4120.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "react3"
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 4241,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 186.31,
    y: 4289.26
  }, "Hooks")))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M575 4120H560.411C559.498 4120 558.612 4120.31 557.901 4120.89L362.306 4278.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "react1"
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 3921,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 142.373,
    y: 3969.26
  }, "React \uAC1C\uBC1C \uAE30\uCD08")))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M575 4120H560.397C559.493 4120 558.615 4119.69 557.907 4119.13L362.321 3963.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "react5"
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 4079,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 1220.26,
    y: 4127.26
  }, "React Router")))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 4120H944.809L1149.81 4119.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "react4"
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1154,
    y: 3934,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 1212.18,
    y: 3982.26
  }, "React \uC0C1\uD0DC \uAD00\uB9AC")))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 4120H943.551C944.37 4120 945.169 4119.75 945.84 4119.28L1150.72 3976.29",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "react6"
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 4224,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 1182.88,
    y: 4272.26
  }, "Styled Components")))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 4120H943.564C944.375 4120 945.166 4120.25 945.834 4120.71L1150.52 4261.73",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "moderncss1"
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1909,
    y: 4490,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 113.261,
    y: 4538.26
  }, "Styled Components")))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M575 4529H559L363.191 4529.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "moderncss2"
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 4650,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 151.112,
    y: 4698.26
  }, "CSS Modules")))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M575 4529H560.41C559.497 4529 558.612 4529.31 557.902 4529.88L362.116 4687.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "moderncss3"
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1154,
    y: 4488,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 1233.95,
    y: 4536.26
  }, "Styled JSX")))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 4529H944.809L1150 4528.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "moderncss4"
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 1153.81,
    y: 4633,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 1244.37,
    y: 4681.26
  }, "Emotion")))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 4529H943.564C944.375 4529 945.166 4529.25 945.834 4529.71L1150.52 4670.73",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "cssframeworks1"
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 4836,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 175.366,
    y: 4884.26
  }, "Tailwind")))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M575 4875.02L363 4875.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "authentication1"
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 5092,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 197.311,
    y: 5140.26
  }, "JWT")))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M575 5131H559L363 5131.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "authentication2"
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 5252,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 150.707,
    y: 5300.26
  }, "Session Auth")))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M575 5131H560.41C559.497 5131 558.612 5131.31 557.902 5131.88L362.116 5289.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "authentication3"
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1154.19,
    y: 5090,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 1256.64,
    y: 5138.26
  }, "OAuth")))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 5131H944.809L1150.19 5130.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "authentication4"
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1154,
    y: 5235,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 1268.51,
    y: 5283.26
  }, "SSO")))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 5131H943.565C944.375 5131 945.166 5131.25 945.833 5131.71L1150.71 5272.73",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "pagerendering1"
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 5501,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 199.374,
    y: 5549.26
  }, "CSR")))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M575 5540H559L363 5540.98",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "pagerendering2"
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 5661,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 199.69,
    y: 5709.26
  }, "SSR")))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M575 5540H560.41C559.497 5540 558.612 5540.31 557.902 5540.88L362.116 5698.49",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "pagerendering3"
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1154.19,
    y: 5499,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 1269.33,
    y: 5547.26
  }, "SSG")))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 5540H944.809L1150.19 5539.02",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "roadmap-node",
    "data-node-id": "pagerendering4"
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1154,
    y: 5644,
    width: 275,
    height: 80,
    rx: 6,
    fill: "#D7EAF8"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fillOpacity: 0.8,
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 24,
    letterSpacing: "-0.019em"
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 1254.04,
    y: 5692.26
  }, "Next.js")))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M928.809 5540H943.565C944.375 5540 945.166 5540.25 945.833 5540.71L1150.71 5681.73",
    stroke: "#0D85DE",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "1 6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595 189C585.611 189 578 196.611 578 206V241.477V318V388C578 399.598 587.402 409 599 409H904C915.598 409 925 399.598 925 388V241.477C925 229.879 915.598 220.477 904 220.477H747.959L743.228 201.821C741.316 194.281 734.529 189 726.75 189H595Z",
    fill: "#A64EFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595 189C585.611 189 578 196.611 578 206V241.477V318V388C578 399.598 587.402 409 599 409H904C915.598 409 925 399.598 925 388V241.477C925 229.879 915.598 220.477 904 220.477H747.959L743.228 201.821C741.316 194.281 734.529 189 726.75 189H595Z",
    fill: "#A64EFF"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontSize: 38,
    fontWeight: "bold",
    letterSpacing: "-0.3px"
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 706.677,
    y: 299.4
  }, "2023\n")), _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 608.567,
    y: 349.4
  }, "\uD504\uB860\uD2B8\uC5D4\uB4DC \uB85C\uB4DC\uB9F5"))));
};
export { SvgFrontendRoadmap2023 as ReactComponent };
export default "data:image/svg+xml;base64,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";